// imageFiles.js
// Import automatique de toutes les images dans src/project/images
const modules = import.meta.glob(
  '@/project/images/**/*.{png,svg,jpg,jpeg,gif}',
  { eager: true },
)

const IMAGES = {}

for (const path in modules) {
  // Conserve le chemin relatif + extension
  // Exemple : /src/project/images/icons/home.svg → icons/home.svg
  const relativePath = path.replace(/^.*\/images\//, '/images/')
  IMAGES[relativePath] = modules[path].default
}

class ImageFiles {
  static get(id) {
    if (!IMAGES[id]) {
      // console.warn(`[ImageFiles] Unknown image ID: "${id}"`)
      return ''
    }
    return IMAGES[id]
  }

  static all() {
    return IMAGES
  }
}

export default ImageFiles
